import { useState } from "react";
import { createPortal } from "react-dom";
import { Modal } from "../../Components/Modal";
import { AllstarModalState } from "MVVM/State/modals";
import { useSetRecoilState } from "recoil";
import { ModalType } from "MVVM/@types";

export const usePortal = (content: JSX.Element, domNode: string = "root") => {
  const [portalOpen, setPortalOpen] = useState<boolean>(false);
  const setAllstarModalState = useSetRecoilState(AllstarModalState); // DO NOT CHANGE, YOU WILL CAUSE INFINITE RENDERS

  const Portal = createPortal(
    <Modal
      isModalOpen={true}
      setModalOpen={() => {
        setPortalOpen(false);
        setAllstarModalState((prev) => ({
          ...prev,
          isOpen: ModalType.None,
        }));
      }}
    >
      {content}
    </Modal>,
    document.getElementById(domNode),
  );

  return { portalOpen, setPortalOpen, Portal };
};
